import dayjs from 'dayjs';

export const schoolTypeOptions = [
    { value: 'darzelis', label: 'Ikimokyklinis ugdymas', color: '#f5222d' }, // ryški raudona
    { value: 'pradine_mokykla', label: 'Pradinė mokykla', color: '#fa8c16' }, // oranžinė
    { value: 'progimnazija', label: 'Progimnazija', color: '#fadb14' }, // geltona
    // { value: 'pagrindine_mokykla', label: 'Pagrindinė mokykla', color: '#52c41a' }, // žalia
    { value: 'gimnazija', label: 'Gimnazija', color: '#fdab01' }, // mėlyna
    // { value: 'sporto_gimnazija', label: 'Sporto gimnazija', color: '#722ed1' }, // violetinė
    { value: 'specialioji_mokykla', label: 'Specialioji mokykla', color: '#eb2f96' }, // rožinė
    // { value: 'jaunimo_mokykla', label: 'Jaunimo mokykla', color: '#13c2c2' }, // cyan / žalsvai mėlyna
    // { value: 'suaugusiuju_mokykla', label: 'Suaugusiųjų mokykla', color: '#a0d911' }, // šviesiai žalia
    // { value: 'menu_mokykla', label: 'Menų mokykla', color: '#fa541c' }, // tamsesnė oranžinė
    // { value: 'profesine_mokykla', label: 'Profesinė mokykla', color: '#2f54eb' },
    { value: 'neformaliojo_vaiku_svietimo_mokykla', label: 'Neformaliojo vaikų švietimo mokykla', color: '#722ed1' },
    { value: 'kita', label: 'Kita', color: '#2f54eb' }, // tamsi mėlyna
];

export const POSITIONS = {
    director: 'Direktorius',
    deputy_director: 'Direktoriaus pavaduotojas',
    secretary: 'Sekretorė',
    it_specialist: 'IT specialistas',
    administrator: 'Administratorius',
    accountant: 'Buhalteris',
    head_teacher: 'Mokytojas metodininkas',
    counselor: 'Vadovas',
    psychologist: 'Psichologas',
    social_worker: 'Socialinis darbuotojas',
    nurse: 'Slaugytoja',
    librarian: 'Bibliotekininkas',
    maintenance: 'Techninis darbuotojas',
    security: 'Apsaugos darbuotojas',
    other: 'Kita',
};

export const subjectOptions = [
    { value: 'matematika', label: 'Matematika', color: '#fdab01' }, // mėlyna
    { value: 'fizika', label: 'Fizika', color: '#722ed1' }, // violetinė
    { value: 'chemija', label: 'Chemija', color: '#eb2f96' }, // rožinė
    { value: 'biologija', label: 'Biologija', color: '#52c41a' }, // žalia
    { value: 'istorija', label: 'Istorija', color: '#fa8c16' }, // oranžinė
    { value: 'geografija', label: 'Geografija', color: '#13c2c2' }, // cyan
    { value: 'lietuviu_kalba', label: 'Lietuvių kalba', color: '#f5222d' }, // raudona
    { value: 'anglu_kalba', label: 'Anglų kalba', color: '#fa541c' }, // tamsesnė oranžinė
    { value: 'vokieciu_kalba', label: 'Vokiečių kalba', color: '#2f54eb' }, // tamsi mėlyna
    { value: 'prancuzu_kalba', label: 'Prancūzų kalba', color: '#a0d911' }, // šviesiai žalia
    { value: 'rusu_kalba', label: 'Rusų kalba', color: '#fadb14' }, // geltona
    { value: 'informatika', label: 'Informatika', color: '#722ed1' }, // violetinė
    { value: 'menai', label: 'Menai', color: '#eb2f96' }, // rožinė
    { value: 'muzika', label: 'Muzika', color: '#fa8c16' }, // oranžinė
    { value: 'dailes_ugdymas', label: 'Dailės ugdymas', color: '#13c2c2' }, // cyan
    { value: 'kuno_kultura', label: 'Kūno kultūra', color: '#52c41a' }, // žalia
    { value: 'technologijos', label: 'Technologijos', color: '#fdab01' }, // mėlyna
    { value: 'psichologija', label: 'Psichologija', color: '#fa541c' }, // tamsesnė oranžinė
    { value: 'filosofija', label: 'Filosofija', color: '#2f54eb' }, // tamsi mėlyna
    { value: 'ekonomika', label: 'Ekonomika', color: '#a0d911' }, // šviesiai žalia
    { value: 'teise', label: 'Teisė', color: '#f5222d' }, // raudona
    { value: 'medicina', label: 'Medicina', color: '#eb2f96' }, // rožinė
    { value: 'inzinerija', label: 'Inžinerija', color: '#722ed1' }, // violetinė
    { value: 'kita', label: 'Kita', color: '#8c8c8c' }, // pilka
];

export const competitionTypeOptions = [
    { value: 'municipal_olympiad', label: 'Savivaldybės olimpiada', color: '#fdab01' }, // mėlyna
    { value: 'national_olympiad', label: 'Nacionalinė olimpiada', color: '#f5222d' }, // raudona
    { value: 'national_competition', label: 'Nacionalinis konkursas', color: '#52c41a' }, // žalia
    { value: 'linesa', label: 'LINESA', color: '#722ed1' }, // violetinė
    { value: 'other', label: 'Kita', color: '#8c8c8c' }, // pilka
];

export const gradeOptions = [
    { value: 1, label: '1 klasė', color: '#fdab01' }, // mėlyna
    { value: 2, label: '2 klasė', color: '#52c41a' }, // žalia
    { value: 3, label: '3 klasė', color: '#fa8c16' }, // oranžinė
    { value: 4, label: '4 klasė', color: '#722ed1' }, // violetinė
    { value: 5, label: '5 klasė', color: '#eb2f96' }, // rožinė
    { value: 6, label: '6 klasė', color: '#13c2c2' }, // cyan
    { value: 7, label: '7 klasė', color: '#fadb14' }, // geltona
    { value: 8, label: '8 klasė', color: '#a0d911' }, // šviesiai žalia
    { value: 9, label: 'I gimnazijos klasė', color: '#f5222d' }, // raudona
    { value: 10, label: 'II gimnazijos klasė', color: '#fa541c' }, // tamsesnė oranžinė
    { value: 11, label: 'III gimnazijos klasė', color: '#2f54eb' }, // tamsi mėlyna
    { value: 12, label: 'IV gimnazijos klasė', color: '#8c8c8c' }, // pilka
];

export const other = [
    { value: 'darzelis', label: 'Darželis', color: 'cyan' },
];

export const roleOptions = [
    { id: 1, name: 'Super Administratorius', label: 'Super Administratorius', color: 'red' },
    { id: 2, name: 'Administratorius', label: 'Administratorius', color: 'volcano' },
    { id: 3, name: 'Švietimo skyrius', label: 'Švietimo skyrius', color: 'geekblue' },
    { id: 4, name: 'Švietimo centras', label: 'Švietimo centras', color: 'blue' },
    { id: 5, name: 'Mokykla', label: 'Mokykla', color: 'green' },
];

export const getProgressColor = (percent: number) => {
    if (percent === 100) return '#52c41a'; // green
    if (percent >= 70) return '#fadb14'; // yellow
    if (percent >= 40) return '#fa8c16'; // orange
    return '#ff4d4f'; // red
};

// Indicator input frequency options (labels, descriptions, colors)
export const frequencyOptions: Record<string, { label: string; description: string; color: string }> = {
    school_year: { label: 'Mokslo metai', description: 'Duomenys renkami kiekvienais mokslo metais', color: 'geekblue' },
    yearly: { label: 'Kiekvienais metais', description: 'Duomenys renkami kiekvienais kalendoriniais metais', color: 'green' },
    quarterly: { label: 'Ketvirtis', description: 'Duomenys renkami kas ketvirtį', color: 'orange' },
    monthly: { label: 'Kas mėnesį', description: 'Duomenys renkami kas mėnesį', color: 'purple' },
    once: { label: 'Vienkartinis', description: 'Duomenys renkami vieną kartą', color: 'red' },
    twice_a_year_july_january: { label: '2 kartus per metus', description: 'Duomenys renkami 2 kartus per metus (liepos ir sausio mėnesiai)', color: 'blue' },
    twice_a_year_may_october: { label: '2 kartus per metus', description: 'Duomenys renkami 2 kartus per metus (gegužės ir spalio mėnesiai)', color: 'blue' },
    semester: { label: 'Pusmetis', description: 'Duomenys renkami kiekvieną mokslo metų pusmetį', color: 'cyan' },
};

export const formatNumber = (value: number | string | null): string => {
    if (value === null || value === undefined) return '0';
    if (typeof value === 'string') {
        // Try to convert string to number
        const numValue = parseFloat(value);
        if (!Number.isNaN(numValue)) {
            return numValue.toLocaleString('lt-LT');
        }
        // If it's not a valid number, return the original string
        return value;
    }
    return value.toLocaleString('lt-LT');
};

export const getSubjectInfo = (subjectValue: string) => subjectOptions.find(subject => subject.value === subjectValue);

export const getCompetitionTypeInfo = (typeValue: string) => competitionTypeOptions.find(type => type.value === typeValue);

export const getGradeInfo = (gradeValue: number) => gradeOptions.find(grade => grade.value === gradeValue);

export const getSchoolTypeInfo = (typeValue: string) => schoolTypeOptions.find(type => type.value === typeValue);

export const placeLevelOptions = [
    { value: 'I', label: 'I vieta', color: '#f5222d' }, // raudona
    { value: 'II', label: 'II vieta', color: '#fa8c16' }, // oranžinė
    { value: 'III', label: 'III vieta', color: '#fadb14' }, // geltona
    { value: 'SPECIAL', label: 'Specialus prizas', color: '#722ed1' }, // violetinė
];

// Common utility functions for school components (Library, Internet, Seminars)

/**
 * Converts string boolean values to actual boolean values
 * Handles cases where API returns "true"/"false" strings instead of boolean
 */
export const convertToBoolean = (value: any): boolean => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') return value === 'true';
    return false;
};

/**
 * Generates time options for Select dropdowns (06:00 to 24:00)
 * Used for working hours selection in Library and Internet components
 */
export const generateTimeOptions = () => {
    const options = [];
    for (let hour = 6; hour <= 24; hour++) {
        const timeString = `${hour.toString().padStart(2, '0')}:00`;
        options.push({
            value: timeString,
            label: timeString,
        });
    }
    return options;
};

/**
 * Helper function to get permission labels
 * Used in Library component for lending and copying permissions
 */
export const getPermissionLabel = (key: string): string => {
    const labels: { [key: string]: string } = {
        institution_staff: 'Institucijos darbuotojams',
        lecturers: 'Lektoriams',
        event_participants: 'Institucijos renginių dalyviams',
        region_teachers: 'Visiems regiono švietimo darbuotojams',
        all_teachers: 'Visiems švietimo darbuotojams',
        students: 'Mokiniams',
        anyone: 'Visiems pageidaujantiems',
    };
    return labels[key] || key;
};

/**
 * Helper function to get material type options for lending permissions
 * Used in Library component for lending permissions dropdown
 */
export const getMaterialTypeOptions = () => [
    { value: 'print', label: 'Spaudiniai' },
    { value: 'cd', label: 'Kompaktiniai diskai' },
    { value: 'event_materials', label: 'Renginių metodinė medžiaga' },
];

/**
 * Helper function to get day labels
 * Used in Library and Internet components for working hours
 */
export const getDayLabel = (day: string): string => {
    const labels: { [key: string]: string } = {
        mon: 'Pirmadienis',
        tue: 'Antradienis',
        wed: 'Trečiadienis',
        thu: 'Ketvirtadienis',
        fri: 'Penktadienis',
        sat: 'Šeštadienis',
        sun: 'Sekmadienis',
    };
    return labels[day] || day;
};

/**
 * Helper function to sort and format working hours with Lithuanian day names
 * Orders days from Monday to Sunday and formats them properly
 */
export const getSortedWorkingHours = (workingHours: Record<string, any>): Array<{ day: string; dayLabel: string; hours: any }> => {
    const dayOrder = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    return dayOrder
        .filter(day => workingHours[day] !== undefined)
        .map(day => ({
            day,
            dayLabel: getDayLabel(day),
            hours: workingHours[day],
        }));
};

/**
 * Helper function to get topic labels for seminars
 * Used in Seminars component for topics offered
 */
export const getTopicLabel = (key: string): string => {
    const labels: { [key: string]: string } = {
        pedagogine_sistema: 'Pedagoginė sistema',
        ugdymo_tikslai: 'Ugdymo tikslai',
        ugdymo_turinys: 'Ugdymo turinys',
        ugdymo_metodai: 'Ugdymo metodai',
        mokytojo_vaidmuo: 'Mokytojo vaidmuo',
        mokinio_veikla: 'Mokinio veikla',
        mokymosi_motyvacija: 'Mokymosi motyvacija',
        vertinimas: 'Vertinimas',
        mokykla: 'Mokykla',
        organizacijos_kultura: 'Organizacijos kultūra',
        mikroklimatas: 'Mikroklimatas',
        socialine_aplinka: 'Socialinė aplinka',
        vadyba: 'Vadyba',
        svietimo_sistema: 'Švietimo sistema',
        svietimo_politika: 'Švietimo politika',
        svietimo_sistemos_struktura: 'Švietimo sistemos struktūra',
        mokytoju_rengimas_kvalifikacija: 'Mokytojų rengimas ir kvalifikacijos tobulinimas',
        pasiekimu_vertinimas_egz_tyrimai: 'Mokymosi pasiekimų vertinimas (egzaminai, tarptautiniai tyrimai)',
    };
    return labels[key] || key;
};

/**
 * Helper function to get target group labels for seminars
 * Used in Seminars component for target group statistics
 */
export const getTargetGroupLabel = (key: string): string => {
    const labels: { [key: string]: string } = {
        ikimokyklinis: 'Ikimokyklinio ugdymo mokytojai',
        priesmokyklinis: 'Priešmokyklinio ugdymo mokytojai',
        pradinis: 'Pradinio ugdymo mokytojai',
        pagr_viduriniai: 'Pagrindinių ir vidurinių mokyklų dalykų mokytojai',
        vadovai: 'Mokyklų vadovai, jų pavaduotojai ugdymui, ugdymą organizuojančių skyrių vedėjai',
        spec_pedagogai: 'Specialiojo ugdymo pedagogai',
        profesinis: 'Profesinio rengimo mokytojai',
        neformalus: 'Neformaliojo vaikų švietimo mokytojai',
        bendruomene: 'Mokyklų bendruomenės, komandos',
        savivaldybiu_darbuotojai: 'Apskričių viršininkų, savivaldybių administracijų švietimo padalinių darbuotojai',
    };
    return labels[key] || key;
};

/**
 * Formats indicator value based on its unit type for bar chart display
 * Handles different indicator types like yes/no, text, numbers, etc.
 */
export const formatIndicatorValueForChart = (value: any, unit: string, hasData: boolean): { displayValue: string; numericValue: number; color?: string } => {
    if (!hasData) {
        return { displayValue: 'Nėra duomenų', numericValue: 0 };
    }

    switch (unit) {
    case 'taip_ne': {
        // For yes/no indicators, convert 1, 1.000, "1", true to "Taip", everything else to "Ne"
        const isYes = value === 1 || value === '1' || value === true
            || (typeof value === 'string' && value.trim() === '1.000')
            || (typeof value === 'number' && value === 1.000);
        const yesNoValue = isYes ? 'Taip' : 'Ne';
        const color = isYes ? '#52c41a' : '#ff4d4f'; // Green for "Taip", Red for "Ne"
        return { displayValue: yesNoValue, numericValue: isYes ? 1 : 0, color };
    }

    case 'text':
        // For text indicators, show the text value directly
        return { displayValue: String(value), numericValue: 1 }; // Use 1 for visualization

    case 'proc': {
        // For percentage indicators, format as percentage
        const percentValue = typeof value === 'number' ? value : parseFloat(value);
        return { displayValue: `${percentValue}%`, numericValue: percentValue };
    }

    case 'eur': {
        // For euro indicators, format as currency
        const euroValue = typeof value === 'number' ? value : parseFloat(value);
        return { displayValue: `${euroValue}€`, numericValue: euroValue };
    }

    case 'eur_thousands': {
        // For thousands of euros indicators, format as currency with thousands
        const euroValue = typeof value === 'number' ? value : parseFloat(value);
        return { displayValue: `${euroValue} tūkst.€`, numericValue: euroValue };
    }

    case 'ratio': {
        // For ratio indicators, show as ratio (e.g., 25/32)
        return { displayValue: String(value), numericValue: 1 }; // Use 1 for visualization
    }

    case 'vnt':
    case 'asm':
    default: {
        // For numeric indicators (units, persons, etc.), format as number
        const numValue = typeof value === 'number' ? value : parseFloat(value);
        return { displayValue: String(numValue), numericValue: numValue };
    }
    }
};

/**
 * Generates a simple user agent hash for frontend identification
 * The actual user identification will be done on the backend using IP + user agent
 */
export const generateUserAgentHash = (): string => {
    const { userAgent } = navigator;
    let hash = 0;

    for (let i = 0; i < userAgent.length; i += 1) {
        const char = userAgent.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = ((hash << 5) - hash) + char;
        // eslint-disable-next-line no-bitwise
        hash &= hash; // Convert to 32-bit integer
    }

    // Convert to a positive hex string and ensure it's always 6 characters
    const positiveHash = Math.abs(hash).toString(16).padStart(6, '0');

    return `ua-${positiveHash}`;
};

/**
 * Generates a survey-specific submission ID that includes user agent hash
 * The backend will combine this with IP address for final identification
 */
export const generateSurveySubmissionId = (surveySlug: string): string => {
    const userAgentHash = generateUserAgentHash();
    // eslint-disable-next-line no-bitwise
    const surveyHash = surveySlug.split('').reduce((hash, char) => ((hash << 5) - hash) + char.charCodeAt(0), 0);

    const surveyHashHex = Math.abs(surveyHash).toString(16).padStart(4, '0');
    return `survey-${userAgentHash}-${surveyHashHex}`;
};

/**
 * Generates a localStorage key for survey submissions using user agent hash
 */
export const getSurveySubmissionKey = (surveySlug: string): string => {
    const userAgentHash = generateUserAgentHash();
    return `survey_submission_${surveySlug}_${userAgentHash}`;
};

/**
 * Generates school year options (e.g. 2024-2025) for select dropdowns
 * Default: start from current school year and generate next 6 ranges
 */
export const generateSchoolYearOptions = (startYear?: number, count = 8) => {
    const currentYear = new Date().getFullYear();
    const baseYear = startYear ?? (currentYear - 4); // start with previous -> covers current school year

    return Array.from({ length: count }).map((_, idx) => {
        const fromYear = baseYear + idx;
        const toYear = fromYear + 1;
        const value = `${fromYear}-${toYear}`;

        return { value, label: `${fromYear}-${toYear} m.m.` };
    });
};

export const isCollectionPeriodMissed = (indicator: { collection_start?: string | null; collection_end?: string | null; period?: string | null; value?: string | null; input_frequency: string }) => {
    if (!indicator.collection_start || !indicator.collection_end || !indicator.period) return false;
    if (indicator.value !== null && indicator.value !== undefined && indicator.value !== '') return false;

    const periodStr = indicator.period;
    const endMonth = parseInt(indicator.collection_end.split('-')[0] || '0', 10);
    const parts = periodStr.split('-');

    let year: number;
    if (periodStr.match(/^\d{4}-\d{4}$/)) {
        const startYear = Number(parts[0]);
        const endYear = Number(parts[1]);
        year = endMonth >= 9 ? startYear : endYear;
    } else if (periodStr.match(/^\d{4}-\d{2}$/)) {
        year = parseInt(parts[0] || '0', 10);
    } else if (periodStr.match(/^Q\d-\d{4}$/)) {
        year = parseInt(parts[1] || '0', 10);
    } else if (periodStr.match(/pusmetis/)) {
        const yearMatch = periodStr.match(/(\d{4})-(\d{4})/);
        if (yearMatch) {
            const startYear = Number(yearMatch[1]);
            const endYear = Number(yearMatch[2]);
            year = endMonth >= 9 ? startYear : endYear;
        } else {
            year = dayjs().year();
        }
    } else {
        year = parseInt(periodStr, 10) || dayjs().year();
    }

    const collectionEndDate = dayjs(`${year}-${indicator.collection_end}`);
    return dayjs().isAfter(collectionEndDate, 'day');
};

// Reusable default list of school years (previous + upcoming)
export const defaultSchoolYearOptions = generateSchoolYearOptions();
// Keep trailing newline for linters
